import styled from 'styled-components';

export const Container = styled.section`
  z-index: 9999;
  background: linear-gradient(
    to right,
    ${({ theme }) => theme.brandBlue.medium},
    ${({ theme }) => theme.brandBlue.dark}
  );
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${({ theme }) => theme.white.a10};
`;

export const SelfSignUpContainer = styled.div`
  margin-top: 4rem;
  padding: 1.3rem;
  width: 100%;
  max-width: 34rem;
`;

export const HeaderContainer = styled.div`
  text-align: center;
  margin-bottom: 1.3rem;
`;
export const HeaderMainInfo = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const HeaderMetaData = styled.div`
  text-align: center;
  margin-bottom: 1.3rem;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-right: 1rem;
`;

export const Title = styled.div`
  font-size: 1.9rem;
  padding: 0rem 1rem;
  font-weight: normal;
`;

export const HeaderMetaImg = styled.img`
  height: 1.7rem;
  color: ${({ theme }) => theme.white.a10};
  margin-left: 0.5rem;
`;

export const MetaDescription = styled.div`
  font-size: 0.9rem;
`;

export const FormContainer = styled.div``;

export const DetailsInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 4rem 0rem 2rem;
`;

export const DetailsText = styled.div`
  font-size: 1.7rem;
`;

export const DetailsDescription = styled.div`
  margin-top: 0.7rem;
  font-size: 1rem;
  font-weight: lighter;
  text-align: center;
  padding: 0rem 3rem;
`;

export const FormGroup = styled.div`
  margin-bottom: 1rem;
`;

export const AttributesSection = styled.div`
  margin: 0.5rem 0rem 1.5rem;
`;

export const Label = styled.div`
  padding: 0.5rem 0px;
  border-radius: 20px;
  font-size: 1rem;
  color: ${({ theme }) => theme.white.a10};
  white-space: nowrap;
  margin-right: 5px;
  cursor: default;
`;

export const AttributesGroup = styled.div``;

export const Footer = styled.div`
  padding: 1rem 3rem;
  justify-content: center;
  margin-top: 0.5rem;
`;

export const ExistingLogin = styled.div`
  color: ${({ theme }) => theme.white.a10};
  font-size: 0.8rem;
  line-height: 24px;
  text-align: center;
  padding-top: 0.5rem;

  &:hover {
    text-decoration: underline;
    color: ${({ theme }) => theme.white.a10};
  }
`;

export const LoginLink = styled.a`
  font-size: 0.8rem;
  color: ${({ theme }) => theme.white.a10};
  margin: 0 5px;
  text-decoration: underline;
`;

export const InfoContainer = styled.div`
  text-align: center;
`;

export const InfoText = styled.span`
  font-size: 0.8rem;
`;

export const InfoLink = styled.div`
  text-align: center;
`;

export const SubText = styled.span`
  width: 37.8rem;
  min-height: 2.806rem;
  font-size: 2.0666rem;
  text-align: center;
  color: ${({ theme }) => theme.white.a10};
  margin-top: 2rem;
  margin-bottom: 4rem;
`;
